import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { NavLink } from "react-router-dom";
import { IonIcon } from "@ionic/react";
import { chevronDownOutline, chevronUpOutline } from "ionicons/icons";
const SidebarLink = ({ icon, label, id, className, isActive, subs, dismiss, badge, dark, ...rest })=>{
    const badgeLabel = typeof badge === 'number' ? badge > 99 ? '99+' : String(badge) : badge;
    const showBadge = badge !== undefined && badge !== null && badge !== 0 && badge !== '';
    const [subOpen, setSubOpen] = React.useState(false);
    const handleClick = (e)=>{
        if (subs) {
            e.preventDefault();
            e.stopPropagation();
            setSubOpen(!subOpen);
            return false;
        }
        if (dismiss) dismiss();
    };
    return /*#__PURE__*/ _jsxs(NavLink, {
        onClick: handleClick,
        to: `/${id}`,
        className: `
                py-2 px-3 hover:opacity-100 rounded space-y-2
                ${' ' + (dark ? isActive ? 'cursor-default !text-[#001865] font-bold border-l-4 !border-[#001865] bg-white/60' : 'cursor-pointer !text-[#001865]/70 font-medium border-l-4 border-transparent hover:!text-[#001865] hover:!border-[#001865]/40 hover:bg-white/40' : isActive ? 'cursor-default text-primary font-bold border-l-4 border-primary dark:border-customs-lavender bg-customs-lavender' : 'cursor-pointer text-text-dark-medium dark:text-text-light-medium font-medium bg-transparent border-l-4 border-transparent hover:text-primary dark:hover:text-primary hover:border-lavender hover:bg-customs-lavender')}
                ${className || ''}
              `,
        ...rest,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-3 items-center justify-start",
                children: [
                    typeof icon === 'string' ? /*#__PURE__*/ _jsx(IonIcon, {
                        icon: icon,
                        className: `text-inherit text-base`
                    }) : icon,
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-sm",
                        children: label
                    }),
                    showBadge && /*#__PURE__*/ _jsx("span", {
                        className: "ml-auto inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-red-500 px-1.5 py-0.5 text-[10px] font-semibold leading-none text-white",
                        children: badgeLabel
                    }),
                    subs && subOpen && /*#__PURE__*/ _jsx(IonIcon, {
                        icon: chevronUpOutline,
                        className: `text-inherit text-base`
                    }),
                    subs && !subOpen && /*#__PURE__*/ _jsx(IonIcon, {
                        icon: chevronDownOutline,
                        className: `text-inherit text-base`
                    })
                ]
            }),
            subs && subOpen && subs.map((sub)=>/*#__PURE__*/ _jsxs(NavLink, {
                    onClick: (e)=>{
                        e.stopPropagation();
                        if (dismiss) dismiss();
                    },
                    to: `/${sub.id}`,
                    className: `
                          flex gap-2 items-center justify-start ml-6 py-0.5 font-normal
                          ${' ' + (dark ? sub.isActive ? '!text-[#001865]' : '!text-[#001865]/70' : sub.isActive ? 'text-primary' : 'text-text-dark-medium dark:text-text-light-medium')}
                      `,
                    children: [
                        icon && (typeof icon === 'string' ? /*#__PURE__*/ _jsx(IonIcon, {
                            icon: sub.icon,
                            className: `text-inherit text-base`
                        }) : sub.icon),
                        /*#__PURE__*/ _jsx("p", {
                            className: "text-sm",
                            children: sub.label
                        })
                    ]
                }))
        ]
    });
};
export default SidebarLink;

//# sourceMappingURL=SidebarLink.js.map